import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import {BASE_API_URL as baseURL} from ".././Constant"
//const baseURL = "http://localhost:1111";
// const baseURL = "https://atcgn.lkm.accenture.com/atcgn-api";

export const IndustryDataSlice = createSlice({
  name: "industryData",
  initialState: {
    data: [],
    fyTarget: { value: '', updated_at: '' },
    isLoading: false,
    error: null,
    success: null,
  },
  reducers: {
    setData: (state, { payload }) => {
      state.data = payload;
      state.error = null;
    },
    setFyTarget: (state, { payload }) => {
      state.fyTarget = payload;
    },
    setLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setSuccess: (state, { payload }) => {
      state.success = payload;
    },
  },
});

export const { setData, setFyTarget, setLoading, setError, setSuccess } = IndustryDataSlice.actions;
export default IndustryDataSlice.reducer;

export const fetchIndustryData = () => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const res = await axios.get(`${baseURL}/get-industry-data`,
      {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    );
    const rawData = res.data.data || [];

    const totalRow = rawData.find(row => row?.region?.toLowerCase?.() === 'total');
    const rest = rawData.filter(row => row?.region?.toLowerCase?.() !== 'total');
    const combined = [...rest];
    if (totalRow) combined.push(totalRow);

    dispatch(setData(combined));
    dispatch(setFyTarget(res.data.fyTarget || { value: '', updated_at: '' }));
  } catch (err) {
    dispatch(setError("Failed to fetch industry data"));
    console.error(err);
  } finally {
    dispatch(setLoading(false));
  }
};


export const uploadIndustryExcel = (file) => async (dispatch) => {
  dispatch(setLoading(true));
  const formData = new FormData();
  formData.append("file", file);

  try {
    await axios.post(`${baseURL}/upload-industry-data`, formData,
      {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      }
    );
    dispatch(fetchIndustryData());
    dispatch(setSuccess("Upload successful"));
  } catch (err) {
    console.error("Upload error:", err);
    dispatch(setError("Upload failed. Please check the file format and try again."));
  } finally {
    dispatch(setLoading(false));
  }
};



